import styled from 'styled-components'

const AlphabetStyled = styled.div`
  width: var(--alphabet-width);
  text-align: justify;
  text-align-last: var(--alphabet-text-align);
`

export default AlphabetStyled
